import ClientCsvUpload from '@/components/ClientCsvUpload';
import Footer from '@/components/Footer';
import ImportedDataView from '@/components/ImportMapping/ImportedData';
import LoanOfficerProfileForm from '@/components/LoanOfficerProfileForm';
import Navbar from '@/components/Navbar';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useState } from 'react';

const LoanOfficerDashboard = () => {
  const [isUpload, setIsUpload] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-8 flex-1">
        <div className="flex items-center space-x-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold text-tax-deepBlue">
              Loan Officer Dashboard
            </h1>
            <p className="text-tax-neutralGray">
              Manage your profile and clients
            </p>
          </div>
        </div>

        <Tabs defaultValue={'profile'} className="space-y-4">
          <TabsList className="border-b w-full justify-start rounded-none bg-transparent p-0">
            <TabsTrigger
              value="profile"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Profile
            </TabsTrigger>
            <TabsTrigger
              value="clients"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Agents
            </TabsTrigger>
          </TabsList>

          <TabsContent value="profile" className="space-y-4">
            <LoanOfficerProfileForm />
          </TabsContent>

          <TabsContent value="clients" className="space-y-4">
            <div>
              {isUpload ? (
                <ClientCsvUpload onBackToList={() => setIsUpload(false)} />
              ) : (
                <ImportedDataView onImportData={() => setIsUpload(true)} />
              )}
            </div>
          </TabsContent>
        </Tabs>
      </div>
      <Footer />
    </div>
  );
};

export default LoanOfficerDashboard;
